import {
  Alert,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  DialogContent,
  Grid,
} from "@mui/material";
import { Button, DialogTitle, Spacer } from "common";
import { useNavigate } from "react-router-dom";

export interface WaiverCreateDialogProps {
  onClose?: Function;
}
export default function WaiverCreateDialog({
  onClose,
}: WaiverCreateDialogProps) {
  const navigate = useNavigate();
  return (
    <>
      <DialogTitle onClose={onClose}>Create Waiver</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} sx={{ display: "flex" }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                borderColor: "divider",
                borderWidth: 1,
                borderStyle: "solid",
              }}
              elevation={0}
            >
              <CardHeader title="Custom Waiver from scratch" />
              <CardContent sx={{ flex: 1 }}>
                Create your waiver add static content (images, texts) mixed up
                with user inputs
              </CardContent>
              <CardActions>
                <Spacer right />
                <Button
                  title={"start"}
                  onClick={() => {
                    navigate("/waivers/create/edit?type=builder");
                  }}
                />
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} sx={{ display: "flex" }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                borderColor: "divider",
                borderWidth: 1,
                borderStyle: "solid",
              }}
              elevation={0}
            >
              <CardHeader title="Pdf Based Waiver" />
              <CardContent sx={{ flex: 1 }}>
                Upload your own waiver PDF and add user inputs under the
                document
              </CardContent>
              <CardActions>
                <Spacer right />
                <Button
                  title={"start"}
                  onClick={() => {
                    navigate("/waivers/create/edit?type=file");
                  }}
                />
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Alert severity="info">You can't change this later.</Alert>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}
